import { render, staticRenderFns } from "./task_add.vue?vue&type=template&id=abfea810&scoped=true"
import script from "./task_add.vue?vue&type=script&lang=js"
export * from "./task_add.vue?vue&type=script&lang=js"
import style0 from "./task_add.vue?vue&type=style&index=0&id=abfea810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfea810",
  null
  
)

export default component.exports